import { useRef } from 'react';

const KEYS: Array<[string, string]> = [
  ['1', ''],
  ['2', 'ABC'],
  ['3', 'DEF'],
  ['4', 'GHI'],
  ['5', 'JKL'],
  ['6', 'MNO'],
  ['7', 'PQRS'],
  ['8', 'TUV'],
  ['9', 'WXYZ'],
  ['*', ''],
  ['0', '+'],
  ['#', ''],
];

/** Phone keypad. Long-press (or right-click) 0 types +. */
export function Keypad({ onKey, compact = false }: { onKey: (key: string) => void; compact?: boolean }) {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const long = useRef(false);
  const cancel = () => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = null;
  };

  return (
    <div className={`keypad${compact ? ' keypad-compact' : ''}`} role="group" aria-label="Keypad">
      {KEYS.map(([k, sub]) => (
        <button
          key={k}
          type="button"
          className="key"
          aria-label={k === '0' ? '0 (hold for +)' : k}
          onPointerDown={() => {
            long.current = false;
            cancel();
            if (k === '0') {
              timer.current = setTimeout(() => {
                long.current = true;
                onKey('+');
              }, 550);
            }
          }}
          onPointerUp={cancel}
          onPointerLeave={cancel}
          onContextMenu={(e) => {
            if (k !== '0') return;
            e.preventDefault();
            if (!long.current) onKey('+');
            long.current = true;
          }}
          onClick={() => {
            if (long.current) {
              long.current = false;
              return;
            }
            onKey(k);
          }}
        >
          <span className="key-main">{k}</span>
          <span className="key-sub">{sub}</span>
        </button>
      ))}
    </div>
  );
}
